import React from 'react'
import Tooltip from 'components/ui/tooltip'
import styles from './index.module.css'

export type Props = {
  children: React.ReactNode
  selected?: boolean
  tooltip: string
  onClick?: (...args: Array<any>) => any
}

const FacetedTag = (props: Props): React.ReactNode => {
  const { selected, tooltip, children, onClick } = props
  return (
    <Tooltip content={tooltip}>
      <div
        className={styles.facetedTag}
        data-selected={selected}
        onClick={onClick}
      >
        {children}
      </div>
    </Tooltip>
  )
}

export default FacetedTag
